// TobaccoLicenseRegistration.jsx
import React from "react";

export default function TobaccoLicenseRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Tobacco License
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Tobacco License Compliance Support
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses in obtaining Tobacco
            Licenses as per applicable state and central laws, helping traders,
            manufacturers, and exporters operate within approved regulatory
            frameworks.[web:228][web:231]
          </p>
          <p className="text-gray-700">
            Support typically covers documentation, application preparation, and
            alignment with tobacco control requirements so that business
            registrations, premises, and records meet licensing expectations.[web:229][web:231]
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/799195/pexels-photo-799195.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Tobacco products on display representing licensing and regulation"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Tobacco License
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps applicants compile core business, KYC,
              and premises documents commonly requested in tobacco-related
              licenses and registrations.[web:228][web:229][web:231]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Business registration certificate such as incorporation
                  certificate, partnership deed, or other proof of business
                  constitution.[web:228][web:231]
                </li>
                <li>
                  PAN and identity proof of the applicant or authorized
                  signatory, together with basic KYC like address details where
                  required.[web:228][web:229][web:231]
                </li>
                <li>
                  Premises address proof (ownership / lease documents and
                  supporting municipal or utility records) for the place of
                  business.[web:228][web:229]
                </li>
                <li>
                  Additional documents sometimes required for specific
                  categories, such as bank certificates, declarations on company
                  letterhead, GST registration, or factory/shop licenses.[web:228][web:232][web:235]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm’s role is to streamline compliance for tobacco-related
              businesses, helping them stay aligned with evolving regulatory
              expectations while focusing on operations.[web:229][web:231]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Knowledge of Tobacco Control Laws
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on how licensing and registration interact with
                  central tobacco legislation, Tobacco Board norms, and
                  state-level trade or municipal requirements.[web:230][web:231][web:232]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Compliance Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance in preparing forms, declarations, and attachments
                  correctly, reducing the chance of delays or rejections in the
                  registration process.[web:228][web:229]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trusted Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Ongoing advisory support from initial application through
                  renewals or updates, providing a steady interface for
                  tobacco-related regulatory interactions.[web:230][web:232]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
